import moment from 'moment';

const contractsFiltersReducerDefaultState = {
    status: null,
    vin: '',
    dealer: null,
    activationStartDate: moment().startOf('day').subtract(1, 'months').toISOString(),
    activationEndDate: moment().toISOString(),
    updatedStartDate: null,
    updatedEndDate: null,
    finalizedStartDate: null,
    finalizedEndDate: null,
    cancelledStartDate: null,
    cancelledEndDate: null,
    page: 1,
    contractId: '',
    contractCustomer: '',
    contractProductName: '',
    contractProductType: null

};

export default (state = contractsFiltersReducerDefaultState, action) => {
    switch (action.type) {
        case 'SET_CONTRACT_STATUS':
            return {
                ...state,
                status: action.status
            };
        case 'SET_CONTRACT_VIN':
            return {
                ...state,
                vin: action.vin
            }
        case 'SET_CONTRACT_DEALER':
            return {
                ...state,
                dealer: action.dealer
            }
        case 'SET_CONTRACT_ACTIVATION_START_DATE':
            return {
                ...state,
                activationStartDate: action.activationStartDate
            }
        case 'SET_CONTRACT_ACTIVATION_END_DATE':
            return {
                ...state,
                activationEndDate: action.activationEndDate
            }
        case 'SET_CONTRACT_UPDATED_START_DATE':
            return {
                ...state,
                updatedStartDate: action.updatedStartDate
            }
        case 'SET_CONTRACT_UPDATED_END_DATE':
            return {
                ...state,
                updatedEndDate: action.updatedEndDate
            }
        case 'SET_CONTRACT_FINALIZED_START_DATE':
            return {
                ...state,
                finalizedStartDate: action.finalizedStartDate
            }
        case 'SET_CONTRACT_FINALIZED_END_DATE':
            return {
                ...state,
                finalizedEndDate: action.finalizedEndDate
            }
        case 'SET_CONTRACT_CANCELLED_START_DATE':
            return {
                ...state,
                cancelledStartDate: action.cancelledStartDate
            }
        case 'SET_CONTRACT_CANCELLED_END_DATE':
            return {
                ...state,
                cancelledEndDate: action.cancelledEndDate
            }
        case 'SET_CONTRACT_PAGE':
            return {
                ...state,
                page: action.page
            }
        case 'SET_CONTRACT_ID':
            return {
                ...state,
                contractId: action.contractId
            }
        case 'SET_CONTRACT_CUSTOMER':
            return {
                ...state,
                contractCustomer: action.contractCustomer
            }
        case 'SET_CONTRACT_PRODUCT_NAME':
            return {
                ...state,
                contractProductName: action.contractProductName
            }
        case 'SET_CONTRACT_PRODUCT_TYPE':
            return {
                ...state,
                contractProductType: action.contractProductType
            }
        default: {
            return state
        };
    };
};
